<template>
  <v-layout justify-center align-center>
    <v-card width="800px" elevation="6">
      <v-layout class="pa-3 docgo" align-center>
        <v-icon color="white" class="pr-2">mdi-settings</v-icon>
        <span class="setting-title">Configuração Geral</span>
      </v-layout>
      <v-layout column class="pa-4">
        <v-layout column align-center justify-center>
          <v-layout style="width: 250px; height: 80px; border: solid 1px">
            <v-img :src="imageUrl" contain />
          </v-layout>
          <v-btn color="docgo" dark>
            <v-icon class="pr-2">mdi-file-image</v-icon>
            Enviar Logo
            <input id="uploader" class="white custom-uploader" type="file" @change="uploadFile" accept=".jpg, .png" />
          </v-btn>
        </v-layout>

        <v-layout column class="mt-1">
          <v-layout>
            <v-flex xs8 class="pr-3">
              <span class="setting-subtitle">Nome da Organização/Empresa</span>
              <v-text-field label="Nome da Organização/Empresa" solo v-model="name" />
            </v-flex>
            <v-flex xs4 class="pl-3">
              <span class="setting-subtitle">Sufixo do Número dos Processos</span>
              <v-text-field label="Sufixo do Número dos Processos" solo v-model="sufix" />
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex xs6 class="pr-3">
              <v-layout column>
                <span class="setting-subtitle">Modelo dos Despachos da Tramitação</span>
                <v-autocomplete single-line v-model="modelDispatch" :items="dispatchModels"
                  :loading="isModelDispatchLoading" :search-input.sync="searchDispatch" solo item-text="name"
                  return-object label="Modelo Padrão de Despachos" no-data-text="Modelo não encontrado"></v-autocomplete>
              </v-layout>
            </v-flex>
            <v-flex xs6 class="pl-3">
              <v-layout column>
                <span class="setting-subtitle">Modelo da Capa da Pasta</span>
                <v-autocomplete single-line v-model="coverDispatch" :items="coverModels" :loading="isCoverDispatchLoading"
                  :search-input.sync="searchCover" solo item-text="name" return-object
                  label="Modelo Padrão de Capa da Pasta" no-data-text="Modelo não encontrado"></v-autocomplete>
              </v-layout>
            </v-flex>

            <v-flex xs6 class="pr-3">
              <v-layout column>
                <span class="setting-subtitle">Modelo do Despacho de Recusa</span>
                <v-autocomplete single-line v-model="refuseDispatch" :items="refuseModels"
                  :loading="isRefuseDispatchLoading" :search-input.sync="searchRefuse" solo item-text="name" return-object
                  label="Modelo Padrão de Despacho de recusa" no-data-text="Modelo não encontrado"></v-autocomplete>
              </v-layout>
            </v-flex>

            <v-flex xs6 class="pl-3">
              <v-layout column>
                <span class="setting-subtitle">Modelo do Despacho de Arquivamento</span>
                <v-autocomplete single-line v-model="archiveDispatch" :items="archiveModels"
                  :loading="isArchiveDispatchLoading" :search-input.sync="searchArchive" solo item-text="name"
                  return-object label="Modelo Padrão de Despacho de Arquivamento"
                  no-data-text="Modelo não encontrado"></v-autocomplete>
              </v-layout>
            </v-flex>

            <v-flex xs6 class="pr-3" v-show="false">
              <v-layout column>
                <span class="setting-subtitle">Status de Arquivamento dos Processos</span>
                <v-autocomplete single-line v-model="statusArchive" :items="statuses" :loading="isStatusesLoading" solo
                  item-text="name" return-object label="Status Padrão de Processos Arquivados"
                  no-data-text="Modelo não encontrado"></v-autocomplete>
              </v-layout>
            </v-flex>

            <v-flex xs6 class="pr-3">
              <v-layout column>
                <span class="setting-subtitle">Status de Processos Novos</span>
                <v-autocomplete single-line v-model="statusNew" :items="statuses" :loading="isStatusesLoading" solo
                  item-text="name" return-object label="Status Padrão de Processos Novos"
                  no-data-text="Modelo não encontrado"></v-autocomplete>
              </v-layout>
            </v-flex>

            <v-flex class="pl-3">
              <v-layout column>
                <span class="setting-subtitle">Unidade Administrativa dos Processos Arquivados</span>
                <v-autocomplete single-line v-model="administrativeUnit" :items="administrativeUnits"
                  :loading="isAdministrativeUnitsLoading" solo item-text="name" return-object
                  label="Setor Padrão de Arquivamento"></v-autocomplete>
              </v-layout>
            </v-flex>
            <v-flex class="pr-1">
              <v-layout column>
                <span class="setting-subtitle">Auto de Infração</span>
                <v-select single-line v-model="infractionModel" :items="infractionModels" solo item-text="name"
                  return-object label="Modelo do Auto de Infração"></v-select>
              </v-layout>
            </v-flex>
            <v-flex class="pl-5">
              <v-layout column>
                <span class="setting-subtitle">Termos Adicionais (Auto de Infração)</span>
                <v-select single-line v-model="additionalTermModel" :items="additionalTermModels" solo item-text="name"
                  return-object label="Modelo dos Termos Adicionais"></v-select>
              </v-layout>
            </v-flex>
          </v-layout>

        </v-layout>
        <v-layout justify-space-between>
          <v-btn :disabled="isSaving" :to="{ name: 'Inbox' }">Cancelar</v-btn>
          <v-btn :loading="isSaving" color="success" dark @click="saveConfigs">
            <v-icon class="mr-2">
              mdi-content-save
            </v-icon>
            Salvar
          </v-btn>
        </v-layout>
      </v-layout>

    </v-card>
  </v-layout>
</template>

<script>
import DocumentService from '@/services/DocumentsService';
import ConfigService from '@/services/system/ConfigService';
import AdministrativeUnitService from '@/services/system/AdministrativeUnitService';
import FolderStatusService from '@/services/system/FolderStatusService';

export default {
  name: 'general-settings',
  components: {
    DocumentService,
    ConfigService,
    AdministrativeUnitService,
    FolderStatusService,
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      isSaving: false,
      file: {},
      imageUrl: '',
      name: '',
      sufix: '',
      modelDispatch: {},
      coverDispatch: {},
      refuseDispatch: {},
      isModelDispatchLoading: false,
      isCoverDispatchLoading: false,
      isRefuseDispatchLoading: false,
      dispatchModels: [],
      coverModels: [],
      refuseModels: [],
      infractionModels: [],
      infractionModel: '',
      additionalTermModels: [],
      additionalTermModel: '',
      searchDispatch: '',
      searchCover: '',
      searchRefuse: '',
      archiveDispatch: {},
      archiveModels: [],
      isArchiveDispatchLoading: false,
      searchArchive: '',
      administrativeUnit: {},
      administrativeUnits: [],
      isAdministrativeUnitsLoading: false,
      statusArchive: {},
      statuses: [],
      isStatusesLoading: false,
      statusNew: {},
    };
  },
  methods: {
    loadData() {
      this.isAdministrativeUnitsLoading = true;
      this.isStatusesLoading = true;
      AdministrativeUnitService.getAllAdministrativeUnits()
        .then(({ data }) => {
          this.administrativeUnits = data;
        })
        .finally(() => this.isAdministrativeUnitsLoading = false);

      FolderStatusService.getFolderStatuses()
        .then(({ data }) => {
          this.statuses = data;
        })
        .finally(() => this.isStatusesLoading = false);

      ConfigService.getConfigs()
        .then(({ data }) => {
          this.name = data.keys.organization_name;
          this.sufix = data.keys.sufix_process_number;
          this.imageUrl = data.logo_url || '';

          this.dispatchModels.push(data.model_todo_transaction);
          this.coverModels.push(data.model_folder_cover);
          this.refuseModels.push(data.model_to_refuse_transaction);
          this.infractionModels.push(data.model_to_infraction);
          this.additionalTermModels.push(data.model_to_additional_terms);
          this.archiveModels.push(data.model_to_archive_folder);

          this.modelDispatch = data.model_todo_transaction;
          this.coverDispatch = data.model_folder_cover;
          this.refuseDispatch = data.model_to_refuse_transaction;
          this.archiveDispatch = data.model_to_archive_folder;
          this.infractionModel = data.model_to_infraction;
          this.additionalTermModel = data.model_to_additional_terms;

          this.administrativeUnit = data.administrative_unit_to_send_archived_folders;
          this.statusArchive = data.folder_status_to_archived_folders;
          this.statusNew = data.folder_status_when_folder_is_created;
        })
        .catch((error) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'success',
            message: error.message,
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
          });
        });
    },
    uploadFile(event) {
      this.file = event.target.files[0];
      this.previewImage();
    },
    previewImage() {
      if (this.file !== undefined) {
        const fr = new FileReader();
        fr.readAsDataURL(this.file);
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result;
        });
      } else {
        this.imageUrl = '';
      }
    },
    saveConfigs() {
      const formData = new FormData();
      formData.append('keys[sufix_process_number]', this.sufix);
      formData.append('keys[document_type_do_transaction_id]', this.modelDispatch.id);
      formData.append('keys[document_type_cover_id]', this.coverDispatch.id);
      formData.append('keys[document_type_refuse_transaction_id]', this.refuseDispatch.id);
      formData.append('keys[document_type_archive_id]', this.archiveDispatch.id);
      formData.append('keys[administrative_unit_to_send_archived_folder_id]', this.administrativeUnit.id);
      formData.append('keys[document_type_infraction_id]', this.infractionModel.id);
      formData.append('keys[document_type_additional_terms_id]', this.additionalTermModel.id);
      formData.append('keys[folder_status_to_archived_folder_id]', this.statusArchive.id);
      formData.append('keys[folder_status_when_folder_is_created_id]', this.statusNew.id);
      formData.append('keys[organization_name]', this.name);
      formData.append('logo', this.file);
      this.isSaving = true;
      ConfigService.createOrUpdateConfigs(formData)
        .then(() => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'success',
            message: 'Configurações alteradas com sucesso!',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
          });
          this.$router.push({ name: 'Inbox' });
        })
        .catch((error) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'success',
            message: error.message,
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
          });
        })
        .finally(() => this.isSaving = false);
    },
  },
  computed: {
  },
  watch: {
    searchDispatch(val) {
      if (val == null) return;
      if (val && val.length < 2) return;
      // Items have already been requested
      if (this.isModelDispatchLoading) return;

      this.isModelDispatchLoading = true;

      // Lazily load input items
      DocumentService.getDocumentTypes(val)
        .then((res) => {
          this.dispatchModels = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isModelDispatchLoading = false));
    },
    searchCover(val) {
      if (val == null) return;
      if (val && val.length < 2) return;
      // Items have already been requested
      if (this.isCoverDispatchLoading) return;

      this.isCoverDispatchLoading = true;

      // Lazily load input items
      DocumentService.getDocumentTypes(val)
        .then((res) => {
          this.coverModels = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isCoverDispatchLoading = false));
    },
    searchRefuse(val) {
      if (val == null) return;
      if (val && val.length < 2) return;
      // Items have already been requested
      if (this.isRefuseDispatchLoading) return;

      this.isRefuseDispatchLoading = true;

      // Lazily load input items
      DocumentService.getDocumentTypes(val)
        .then((res) => {
          this.refuseModels = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isRefuseDispatchLoading = false));
    },
    searchArchive(val) {
      if (val == null) return;
      if (val && val.length < 2) return;
      // Items have already been requested
      if (this.isArchiveDispatchLoading) return;

      this.isArchiveDispatchLoading = true;

      // Lazily load input items
      DocumentService.getDocumentTypes(val)
        .then((res) => {
          this.archiveModels = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isArchiveDispatchLoading = false));
    },
  },
};
</script>

<style scoped lang="scss">
.fill {}

.setting-title {
  color: white;
  font-size: 18px;
}

.setting-subtitle {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  font-weight: bold;
}

.custom-uploader {
  cursor: pointer;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 99;
  opacity: 0;
  border: 18px solid black;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/GeneralSettings.vue